/**
 * CommentListWrap
 */

import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';

class CommentListWrap {

	private $parent: any;

	private _id: string;

	private articleId: string;

	private id: string;

	constructor( $parent: any, articleId: string/*, callback */ ) {
		this.$parent = $parent;
		this._id = this.$parent.attr( 'id' );
		this.articleId = articleId;
		// this.callback = callback;
		this.id = 'commentThread';
	}

	public template( list: any ) {
		return Util.Tmpl.render({
			data: list,
			template: ( items: string ) => `<div class="comment-body"><div class="commentThread comment-thread">${items}</div></div>`,
		});
	}

	public getNode() {
		return jQuery( `#${this._id} .${this.id}` );
	}

	public getChildren() {
		return jQuery( `#${this._id} .${this.id}` ).children();
	}

	public empty() {
		jQuery( `#${this._id} .${this.id}` ).empty();
	}

	public appendList( list: any ) {
		jQuery( `#${this._id} .${this.id}` ).append( list );
	}

	public setUI( data: any ) {
		return this.template( data );
	}
}

export default CommentListWrap;
